/**
 * Copy text to clipboard with execCommand fallback for non-HTTPS origins.
 *
 * Primary: navigator.clipboard.writeText (requires HTTPS or localhost).
 * Fallback: hidden textarea + document.execCommand('copy') (deprecated but
 * works in all browsers, needed for dev on LAN HTTP).
 *
 * Returns true if copy succeeded, false if both paths failed.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Fallback for non-HTTPS (dev env) — execCommand is deprecated but universal
    try {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(ta)
      return ok
    } catch {
      return false
    }
  }
}
